import React, { Component } from "react";
import { Buffer } from "buffer";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import BackupIcon from "@mui/icons-material/Backup";
import Multiselect from "multiselect-react-dropdown";
import Button from "@material-ui/core/Button";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
// import Quill from "./quill/Quill";
// import Tooltip from "./tooltip/Tooltip";
import SaveButton from "../buttons/SaveButton";
// import CancelIconButton from "../buttons/CancelIconButton";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import "./WidgetTemplate.css";
import PtsAlert from "../ptsAlert/PtsAlert";
import {
  AllGroupList_Url,
  GetWidget_Url,
  UpdateWidget_Url,
} from "../../../provider/ServiceUrl";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import SunEditor from "suneditor-react";
import plugins from "suneditor/src/plugins";
import { en } from "suneditor/src/lang";
import katex from "katex";
import "suneditor/dist/css/suneditor.min.css";
import "katex/dist/katex.min.css";
// import defaultWidget_logo from "../../../assets/img/defaultWidget_logo.jpg";

class WidgetTemplate extends Component {
  smsVariablesList = store.getState().staticData.smsVariablesList;
  header = store.getState().header.header;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  breadCrumb = [
    { pageid: "/messages", uiname: " Message List" },
    { pageid: "", uiname: " Widget Details" },
  ];

  constructor(props) {
    super(props);
    let action = props.action;
    let messageId = props.messageId;
    if (!action && props.state) {
      action = props.state.action;
      messageId = props.state.messageId;
    }
    this.state = {
      messageId: messageId,
      message: "",
      mobileNo: "",
      iframeCode: "",
      textColor: "#3d85c6",
      selectedFile: { name: "" },
      widgetTemplateGroups: [],
      smsGroupList: [],
      groupList: [],
      currentFile: null,
      isFirstName: false,
      isLastName: false,
      isEmail: false,
      isFirstNameRequired: false,
      isLastNameRequired: false,
      isEmailRequired: false,
      copied: false,
      alertVisible: false,
      open: false,
      isOpen: false,
      render: false,
      showFileView: false,
      isDragging: false,
      isOrglogoAsWidgetLogo: false,
      orgLogo: null,
    };
  }

  getGroupList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(AllGroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          this.setState({
            smsGroupList: smsGroupList,
          });
        } else {
        }
      }
    );
  }

  showWidgetDetails(message) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: message?.id,
      },
      //   event: {
      //     id: this.businessDomainId,
      //   },
    };
    FetchServerData.callPostService(GetWidget_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let widgetTemplate = output.data.widgetTemplate;
          let getPermission = Utils.getRolePermission(["*"]);
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let widgetTemplateGroups = [];
          this.getGroupList();

          for (
            let k = 0;
            k < widgetTemplate?.widgetTemplateGroups?.length;
            k++
          ) {
            const element = widgetTemplate?.widgetTemplateGroups[k]?.smsGroup;

            if (element !== null && element !== undefined) {
              widgetTemplateGroups.push(element);
            }
          }

          const imageSrc =
            widgetTemplate?.bannerImage !== null
              ? widgetTemplate?.bannerImage
              : (widgetTemplate?.orgLogo !== null && widgetTemplate?.isOrglogoAsWidgetLogo)
                ? widgetTemplate?.orgLogo
                : "";


          if (widgetTemplate?.bannerImage !== null) {
            // showFile = true;
            let byteArray = "";
            let widgetBannerUrl =
              "data:application/*;base64," + widgetTemplate?.bannerImage;
            if (widgetTemplate?.bannerImage !== null) {
              byteArray = new Buffer(
                widgetTemplate?.bannerImage?.replace(/^.+base64,/, ""),
                "base64"
              );
              const url = URL.createObjectURL(new Blob([byteArray]));
              let fileName = widgetBannerUrl;

              let urlArr = fileName.split(".");
              let fileType = urlArr[1];
              this.setState({
                newUrl: url,
                fileType: fileType,
                open: true,
                showFileView: true,
              });
            }
          } else {
            this.setState({
              newUrl: imageSrc,
              showFileView: imageSrc === "" ? false : true,
              selectedFile: { name: "" },
            });
          }
          // this.editorRef.current.innerHTML =
          //   "<></p><h3><fontstyle= font-size: 24px; color=#3d85c6 face=Arial ><b> Widget Title Goes Here </b></font></h3><p></p><p></p><h4><fontstyle=font-size: 14px;face=Arial><b>Enteryourmobilenumber.We'll text you! </b></font></h4> <p></p>";
          this.setState({
            render: true,
            openWidget: true,
            currentFile: null,
            action: "view",
            messageId: message?.id,
            messageName: message?.messagename,
            widgetId: widgetTemplate?.id,
            message: widgetTemplate?.title,
            isFirstName: widgetTemplate.isFirstName,
            isLastName: widgetTemplate.isLastName,
            isEmail: widgetTemplate.isEmail,
            isFirstNameRequired: widgetTemplate.isFirstNameRequired,
            isLastNameRequired: widgetTemplate.isLastNameRequired,
            isEmailRequired: widgetTemplate.isEmailRequired,
            url: widgetTemplate?.url,
            iframeCode: widgetTemplate.iframeCode,
            isOrglogoAsWidgetLogo: widgetTemplate?.bannerImage === null ? widgetTemplate.isOrglogoAsWidgetLogo : false,
            orgLogo: widgetTemplate.orgLogo,
            groupList: widgetTemplateGroups,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleMobileNoChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        mobileNo: value,
        mobile: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handleFirstNameChange(e) {
    this.setState({
      isFirstName: e.target.checked,
      isFirstNameRequired: false,
    });
  }
  handleFirstNameRequiredChange(e) {
    this.setState({ isFirstNameRequired: e.target.checked });
  }

  handleLastNameChange(e) {
    this.setState({ isLastName: e.target.checked, isLastNameRequired: false });
  }
  handleLastNameRequiredChange(e) {
    this.setState({ isLastNameRequired: e.target.checked });
  }
  handleEmailChange(e) {
    this.setState({ isEmail: e.target.checked, isEmailRequired: false });
  }
  handleEmailRequiredChange(e) {
    this.setState({ isEmailRequired: e.target.checked });
  }

  // handleMessageChange(value) {
  //   this.setState({ message: value });
  // }

  editCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventMessages", {
        state: {
          action: "view",
          eventId: this.businessDomainId,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessages", {
        state: {
          action: "view",
          eventId: this.businessDomainId,
        },
      });
    } else {
      this.props.navigate("/messages");
    }
  }

  handleChecked(e, id) {
    let newItems = [...this.state.smsGroupList];
    for (let i = 0; i < newItems.length; i++) {
      const element = newItems[i];
      if (element.id === id) {
        newItems[i].checked = !newItems[i].checked;
      }
    }
  }

  onCopy = (e) => {
    this.setState({ copied: true });
  };
  handleCopy = (e) => {
    this.setState({ alertVisible: true });
    setTimeout(() => {
      this.setState({ alertVisible: false, copiedIndex: null });
    }, 1000);
  };

  updateWidgetTemplateBackend(isMessage) {
    let widgetTemplateGroups = [];
    for (let i = 0; i < this.state.groupList?.length; i++) {
      widgetTemplateGroups.push(this.state.groupList[i]?.id);
    }
    const postObject = {
      header: this.header,
      smsMessage: {
        id: this.state.messageId,
        widgetTemplate: {
          id: this.state.widgetId,
          title: this.state.message,
          isFirstName: this.state.isFirstName,
          isLastName: this.state.isLastName,
          isEmail: this.state.isEmail,
          isFirstNameRequired: this.state.isFirstNameRequired,
          isLastNameRequired: this.state.isLastNameRequired,
          isEmailRequired: this.state.isEmailRequired,
          isOrglogoAsWidgetLogo: this.state.isOrglogoAsWidgetLogo,
          groupList: widgetTemplateGroups,
        },
      },
    };
    FetchServerData.callPostService(UpdateWidget_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          {
            isMessage && PtsAlert.success(output.message);
          }
          let widgetTemplate = output.data.widgetTemplate;
          let getPermission = Utils.getRolePermission(["*"]);
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let widgetTemplateGroups = [];

          for (
            let k = 0;
            k < widgetTemplate?.widgetTemplateGroups?.length;
            k++
          ) {
            const element = widgetTemplate?.widgetTemplateGroups[k]?.smsGroup;

            if (element !== null && element !== undefined) {
              widgetTemplateGroups.push(element);
            }
          }

          this.setState({
            render: true,
            action: "view",
            widgetId: widgetTemplate.id,
            message: widgetTemplate.title,
            isFirstName: widgetTemplate.isFirstName,
            isLastName: widgetTemplate.isLastName,
            isEmail: widgetTemplate.isEmail,
            isFirstNameRequired: widgetTemplate.isFirstNameRequired,
            isLastNameRequired: widgetTemplate.isLastNameRequired,
            isEmailRequired: widgetTemplate.isEmailRequired,
            url: widgetTemplate.url,
            iframeCode: widgetTemplate.iframeCode,
            isOrglogoAsWidgetLogo: widgetTemplate.isOrglogoAsWidgetLogo,
            orgLogo: widgetTemplate.orgLogo,
            groupList: widgetTemplateGroups,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      }
    );
  }

  rowItemSelected(e, rowData) {
    let selectedItems = this.state.smsGroupList;
    for (let i = 0; i < selectedItems.length; i++) {
      if (rowData.id === selectedItems[i].id) {
        if (e.target.checked) {
          selectedItems[i].isSelected = true;
        } else {
          selectedItems[i].isSelected = false;
        }
      }
    }

    let groupList = [];
    for (let i = 0; i < selectedItems.length; i++) {
      if (selectedItems[i].isSelected === true) {
        groupList.push(selectedItems[i].id);
      }
    }
    this.setState({
      smsGroupList: selectedItems,
      groupList: groupList,
    });
  }

  onSelectGroups(selectedList) {
    this.setState({
      groupList: selectedList,
    });
  }
  onRemoveGroups(selectedList) {
    this.setState({
      groupList: selectedList,
    });
  }

  handleWidgetClose() {
    this.setState({ openWidget: false });
  }

  // onFileChange = (event) => {
  //   // Update the state
  //   let currentFile = null;
  //   if (event.target.files[0]) {
  //     currentFile = URL.createObjectURL(event.target.files[0]);
  //   }

  //   const file = event.target.files[0];
  //   if (file) {
  //     const img = new Image();
  //     const reader = new FileReader();

  //     reader.onload = (e) => {
  //       img.src = e.target.result;

  //       img.onload = () => {
  //         // Check the image dimensions
  //         if (img.width <= 300 && img.height <= 100) {
  //           this.setState({
  //             imagePreview: e.target.result,
  //             imageError: "",
  //             selectedFile: event.target.files[0],
  //             currentFile: currentFile,
  //           });
  //         } else {
  //           this.setState({
  //             selectedFile: event.target.files[0],
  //             currentFile: currentFile,
  //             imagePreview: null,
  //             imageError: "The selected file is not the required type or size.",
  //           });
  //         }
  //       };
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
      this.onLogoChange(file);
    }
  };

  handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({ selectedFile: file, isDragging: false });
      this.onLogoChange(file);
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  onLogoChange(file) {
    // const file = event.target.files[0];
    if (!file) return;

    // 1. Validate file type
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];
    if (!allowedTypes.includes(file.type)) {
      this.setState({
        imageError: "The file type is not supported (must be png, jpg, gif).",
      });
      return;
    }

    // 2. Validate file size (<= 5 MB)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      this.setState({
        imageError: "The file size is too large (5 MB maximum).",
      });
      return;
    }

    // 3. Validate dimensions using Image object
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);

      if (img.width > 300 || img.height > 100) {
        this.setState({
          imageError:
            "The image dimensions are too big (300 × 100 pix maximum).",
        });
        return;
      }

      // ✅ All validations passed: set state and call upload
      this.setState(
        {
          imagePreview: objectUrl,
          imageError: "",
          selectedFile: file,
          currentFile: objectUrl,
        },
        () => this.uploadWidgetBanner()
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      this.setState({ imageError: "Invalid image file." });
    };

    img.src = objectUrl;
  }

  uploadWidgetBanner = (e) => {
    if (!this.state.selectedFile?.name || this.state.selectedFile?.name === "") {
      PtsAlert.error("Please select file to upload");
      return;
    }
    let header = store.getState().header.header;
    const formData = new FormData();
    formData.append(
      "file",
      this.state.selectedFile,
      this.state.selectedFile?.name
    );
    formData.append("tid", header.tid);
    formData.append("sessionid", this.header.sessionid);
    formData.append("userid", this.header.userid);
    formData.append("isAp", header.isAp);
    formData.append("appclient", header.appclient);
    formData.append("smsmessageid", this.state.messageId);
    // Details of the uploaded file

    FetchServerData.callPostService(
      "/smsmessagems/uploadWidgetBanner",
      formData
    ).then((output) => {
      if (output.status === "SUCCESS") {
        this.fileUploadRef.current.value = "";
        let widgetBannerData = output.data.widgetTemplate;
        if (widgetBannerData?.bannerImage !== null) {
          // showFile = true;
          let byteArray = "";
          let widgetBannerUrl =
            "data:application/*;base64," + widgetBannerData?.bannerImage;
          if (widgetBannerData?.bannerImage !== null) {
            byteArray = new Buffer(
              widgetBannerData?.bannerImage?.replace(/^.+base64,/, ""),
              "base64"
            );
            const url = URL.createObjectURL(new Blob([byteArray]));
            let fileName = widgetBannerUrl;

            let urlArr = fileName.split(".");
            let fileType = urlArr[1];
            this.setState({
              newUrl: url,
              fileType: fileType,
              open: true,
              showFileView: true,
            });
          }
        }

        // this.setState({
        //   render: true,
        //   action: "view",
        //   currentFile: null,
        //   selectedFile: logoData,
        // });
      }
    });
  };

  deleteWidgetBannerInBackend() {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: this.state.messageId,
      },
    };
    FetchServerData.callPostService(
      "/smsmessagems/deleteWidgetBanner",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        // PtsAlert.success(output.message);
        this.setState({
          newUrl: "",
          currentFile: null,
          selectedFile: { name: "" },
          fileType: "",
          fileName: "",
          showFileView: false,
          isOrglogoAsWidgetLogo: false,
        });
      } else {
      }
    });
  }

  saveSelection = () => {
    let sel = window.getSelection();
    if (sel.rangeCount > 0) {
      this.savedRange = sel.getRangeAt(0);
    }
  };

  restoreSelection = () => {
    let sel = window.getSelection();
    if (this.savedRange) {
      sel.removeAllRanges();
      sel.addRange(this.savedRange);
    }
  };

  handleChange(newContent) {
    this.setState({ message: newContent });
  };

  execCommand = (command, value = null) => {
    this.saveSelection(); // Save selection before applying command
    document.execCommand(command, false, value);
    this.handleChange();
    // this.restoreSelection(); // Restore selection after applying command
  };

  changeFontSize = (size) => {
    this.saveSelection(); // Save current selection
    document.execCommand("fontSize", false, "7"); // Apply font size (temp)

    let fontElements = document.querySelectorAll("font[size='7']");
    fontElements.forEach((el) => {
      el.removeAttribute("size"); // Remove the default execCommand size
      el.style.fontSize = `${size}px`; // Apply custom size
    });
    this.handleChange(); // Update state/content
  };

  handleColorChange = (e) => {
    this.saveSelection();
    const color = e.target.value;
    document.execCommand("foreColor", false, color);

    // this.setState({ textColor: color }, () => {
    //   // this.restoreSelection(); // Restore selection after applying color
    // });
    this.handleChange();
  };

  formatText(command, value = null) {
    document.execCommand(command, false, value);
  }

  handleMouseUp = () => {
    this.saveSelection();
  };

  componentDidMount() {
    this.editorRef.current?.editor?.focus();
  }

  handleIsOrgLogoAsWidgetLogoChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      this.setState({
        isOrglogoAsWidgetLogo: true,
        newUrl: this.state.orgLogo,
        showFileView: true
      });
    } else {
      this.setState({
        newUrl: "",
        currentFile: null,
        selectedFile: { name: "" },
        fileType: "",
        fileName: "",
        showFileView: false,
        isOrglogoAsWidgetLogo: false,
      })
    }

  };

  render() {
    this.fileUploadRef = React.createRef();
    this.editorRef = React.createRef();
    // const imageSrc =
    //   this.state.newUrl
    //     ? this.state.newUrl
    //     : this.state.orgLogo
    //       ? this.state.orgLogo
    //       : defaultWidget_logo;

    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <Dialog
          open={this.state.openWidget}
          onClose={this.handleWidgetClose.bind(this)}
          maxWidth="xl"
          className="widgetDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>
              {`Opt-in Widget Editor for Message: ${this.state.messageName}`}
            </span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleWidgetClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent style={{ overflowX: "hidden" }}>
            <div
              md={12}
              style={{
                width: "100%",
                color: "#000",
                fontSize: "small",
                padding: "0.5em",
              }}
            >
              <div className="row">
                <div className="col-md-12">
                  {/* <div className="card" id="giveBeeCard">
                    <div className="card-body"> */}
                  <label
                    className="form-label fs-5"
                    htmlFor="collapsible-firstname"
                  >
                    Customize your opt-in widget, then click Preview & Test to
                    see results.
                  </label>
                  <div className="row mb-4 mt-3">
                    <div className="form-group col-lg-6 col-sm-6">
                      <div className="row">
                        <b>Fields</b>
                      </div>
                      <div className="row mt-2">
                        <div
                          className="col-md-4 d-flex align-items-center pe-0"
                          id="assetFormLabel"
                        >
                          <span className="me-1" style={{ marginTop: "1px" }}>
                            <input
                              type="checkbox"
                              id="firstname-checkbox"
                              value={this.state.isEmailRequired}
                              onChange={(e) => this.handleFirstNameChange(e)}
                              checked={this.state.isFirstName}
                            />
                          </span>

                          <label
                            className="form-label"
                            htmlFor="firstname-checkbox"
                            style={{ cursor: "pointer" }}
                          >
                            First Name
                          </label>
                        </div>
                        {this.state.isFirstName && (
                          <div
                            className="col-md-8 d-flex align-items-center"
                            id="assetFormLabel"
                          >
                            <span className="me-1" style={{ marginTop: "1px" }}>
                              <input
                                type="checkbox"
                                id="firstrequired-checkbox"
                                value={this.state.isFirstNameRequired}
                                onChange={(e) =>
                                  this.handleFirstNameRequiredChange(e)
                                }
                                checked={this.state.isFirstNameRequired}
                              />
                            </span>

                            <label
                              className="form-label fw-normal"
                              htmlFor="firstrequired-checkbox"
                              style={{ cursor: "pointer" }}
                            >
                              required
                            </label>
                          </div>
                        )}
                      </div>
                      <div className="row d-flex">
                        <div
                          className="col-md-4 d-flex align-items-center pe-0"
                          id="assetFormLabel"
                        >
                          <span className="me-1" style={{ marginTop: "1px" }}>
                            <input
                              type="checkbox"
                              id="lastname-checkbox"
                              value={this.state.isLastName}
                              onChange={(e) => this.handleLastNameChange(e)}
                              checked={this.state.isLastName}
                            />
                          </span>

                          <label
                            className="form-label"
                            htmlFor="lastname-checkbox"
                            style={{ cursor: "pointer" }}
                          >
                            Last Name
                          </label>
                        </div>
                        {this.state.isLastName && (
                          <div
                            className="col-md-8 d-flex align-items-center"
                            id="assetFormLabel"
                          >
                            <span className="me-1" style={{ marginTop: "1px" }}>
                              <input
                                type="checkbox"
                                id="lastrequired-checkbox"
                                value={this.state.isLastNameRequired}
                                onChange={(e) =>
                                  this.handleLastNameRequiredChange(e)
                                }
                                checked={this.state.isLastNameRequired}
                              />
                            </span>

                            <label
                              className="form-label fw-normal"
                              htmlFor="lastrequired-checkbox"
                              style={{ cursor: "pointer" }}
                            >
                              required
                            </label>
                          </div>
                        )}
                      </div>
                      <div className="row d-flex">
                        <div
                          className="col-md-4 d-flex align-items-center pe-0"
                          id="assetFormLabel"
                        >
                          <span className="me-1" style={{ marginTop: "1px" }}>
                            <input
                              type="checkbox"
                              id="email-checkbox"
                              value={this.state.isEmail}
                              onChange={(e) => this.handleEmailChange(e)}
                              checked={this.state.isEmail}
                            />
                          </span>

                          <label
                            className="form-label"
                            htmlFor="email-checkbox"
                            style={{ cursor: "pointer" }}
                          >
                            Email
                          </label>
                        </div>
                        {this.state.isEmail && (
                          <div
                            className="col-md-8 d-flex align-items-center"
                            id="assetFormLabel"
                          >
                            <span className="me-1" style={{ marginTop: "1px" }}>
                              <input
                                type="checkbox"
                                id="emailreqired-checkbox"
                                value={this.state.isEmailRequired}
                                onChange={(e) =>
                                  this.handleEmailRequiredChange(e)
                                }
                                checked={this.state.isEmailRequired}
                              />
                            </span>

                            <label
                              className="form-label fw-normal"
                              htmlFor="emailreqired-checkbox"
                              style={{ cursor: "pointer" }} // Optional: show pointer on hover
                            >
                              required
                            </label>
                          </div>
                        )}
                      </div>
                      <div className="row mt-2" style={{ width: "335px" }}>
                        <b>Select Group Options</b>
                        <div className="row mt-2 widget">
                          <Multiselect
                            className="widget-multiselect"
                            onRemove={this.onRemoveGroups.bind(this)}
                            onSelect={this.onSelectGroups.bind(this)}
                            options={this.state.smsGroupList}
                            selectedValues={this.state.groupList}
                            displayValue="name"
                            showCheckbox
                            placeholder={
                              this.state.groupList.length === 0
                                ? "None"
                                : this.state.groupList.length > 1
                                  ? `${this.state.groupList.length} groups selected`
                                  : `${this.state.groupList.length} group selected`
                            }
                            hideSelectedList={true}
                            showArrow={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="form-group col-lg-6 col-sm-6"
                      id="sunWidgetTextEditor"
                      style={{ width: "346.6px" }}
                    >
                      {/* <Quill
                        text={this.state.message}
                        onChange={this.handleMessageChange.bind(this)}
                        className="templateMessageBox"
                      /> */}
                      <SunEditor
                        ref={this.editorRef}
                        setContents={this.state.message}
                        onChange={this.handleChange.bind(this)}
                        setDefaultStyle="font-size: 14px; font: Arial;"
                        enableToolbar={true}
                        setOptions={{
                          callFocus: true,
                          fontSort: false,
                          attributesWhitelist: {
                            all: "style",
                          },
                          plugins: plugins,
                          resizingBar: false,
                          height: 180,
                          katex: katex,
                          lang: en,
                          defaultStyle: "font-family: Arial; font-size: 14px;",
                          buttonList: [
                            [
                              "font",
                              "fontSize",
                              "bold",
                              "italic",
                              "underline",
                              "fontColor",
                            ],
                          ],
                          icons: {
                            bold: '<span class="gb-icon-bold">B</span>',
                            italic: '<span class="gb-icon-italic">I</span>',
                            underline: '<span class="gb-icon-underline">U</span>',
                            fontColor: '<span class="gb-color-icon"></span>',
                          },
                          font: [
                            "Arial",
                            "Helvetica",
                            "Georgia",
                            "Times New Roman",
                            "Verdana",
                          ],
                          fontSize: [8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28],
                          colorList: [
                            // exact grayscale row
                            ["#000000", "#434343", "#666666", "#999999", "#b7b7b7", "#cccccc", "#d9d9d9", "#efefef", "#f3f3f3", "#ffffff"],
                            // exact rainbow row
                            ["#980000", "#ff0000", "#ff9900", "#ffff00", "#00ff00", "#00ffff", "#4a86e8", "#0000ff", "#9900ff", "#ff00ff"],
                            // gradient grid row 2
                            ["#dd7e6b", "#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#a4c2f4", "#9fc5e8", "#b4a7d6", "#d5a6bd"],
                            // gradient grid row 3
                            ["#cc4125", "#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6d9eeb", "#6fa8dc", "#8e7cc3", "#c27ba0"],
                            // gradient grid row 4
                            ["#a61c00", "#cc0000", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3c78d8", "#3d85c6", "#674ea7", "#a64d79"],
                            // gradient grid row 5
                            ["#85200c", "#990000", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#1155cc", "#0b5394", "#351c75", "#741b47"],
                            // gradient grid row 6
                            ["#5b0f00", "#660000", "#783f04", "#7f6000", "#274e13", "#0c343d", "#1c4587", "#073763", "#20124d", "#4c1130"]
                          ]
                        }}
                        placeholder="Please type here..."
                      />
                    </div>
                  </div>
                  <div
                    className="row"
                    style={{ borderTop: "1px solid lightgray" }}
                  >
                    <div className="col-md-6">
                      <div
                        className="row"
                        md={12}
                        style={{
                          alignItems: "flex-end",
                          margin: "1em 0em 0em 0em",
                        }}
                      >
                        <div className="row">
                          <label
                            className="col-md-4"
                            style={{
                              color: "#000",
                              fontWeight: "600",
                              padding: "0px",
                            }}
                          >
                            <b>Add Logo</b>
                          </label>
                          <div
                            className="col-md-8 d-flex align-items-center"
                            id="assetFormLabel"
                          >
                            {this.state.orgLogo !== null &&
                              <>
                                <span className="me-1" style={{ marginTop: "1px" }}>
                                  <input
                                    type="checkbox"
                                    id="companyLogo-checkbox"
                                    value={this.state.isOrglogoAsWidgetLogo}
                                    onChange={(e) =>
                                      this.handleIsOrgLogoAsWidgetLogoChange(e)
                                    }
                                    checked={this.state.isOrglogoAsWidgetLogo}
                                  />
                                </span>
                                <label
                                  className="form-label fw-normal"
                                  htmlFor="companyLogo-checkbox"
                                  style={{ cursor: "pointer" }}
                                >
                                  Use Company Logo
                                </label>
                              </>
                            }
                          </div>
                        </div>
                        <div className="row mt-2" style={{ minHeight: "100px" }}>
                          {!this.state.showFileView ? (
                            <>
                              <div className="col-sm-10 align-self-center p-0">

                                <div
                                  className="file-upload-wrapper"
                                  style={{ width: "max-content" }}
                                >
                                  <label
                                    htmlFor="file-upload"
                                    className={`customImageVideo-file-upload ${this.state.isDragging ? "dragging" : ""
                                      }`}
                                    onDrop={this.handleDrop}
                                    onDragOver={this.handleDragOver}
                                    onDragLeave={this.handleDragLeave}
                                  >
                                    <CloudUploadIcon className="upload-icon" />
                                    <span className="upload-text">
                                      Drop file here or{" "}
                                      <span className="browse-link">Browse for file</span>
                                    </span>

                                    <input
                                      required
                                      id="file-upload"
                                      type="file"
                                      ref={this.fileUploadRef}
                                      onChange={this.handleFileChange.bind(
                                        this
                                      )}
                                      onClick={(e) => {
                                        e.target.value = null;
                                        this.setState({
                                          imageError: "",
                                          selectedFile: { name: "" },
                                        });
                                      }}
                                    />
                                  </label>

                                  <small
                                    className="upload-note"
                                    style={{ fontSize: "10px" }}
                                  >
                                    (300x100 pix - PNG, JPG, GIF)
                                  </small>
                                </div>
                              </div>
                              {/* {this.state.currentFile &&
                                !this.state.imageError && (
                                  <div>
                                    <img
                                      style={{
                                        width: "-webkit-fill-available",
                                        height: "4em",
                                        objectFit: "contain",
                                        objectPosition: "left",
                                      }}
                                      alt=""
                                      src={
                                        this.state.currentFile
                                          ? this.state.currentFile
                                          : ""
                                      }
                                    />
                                  </div>
                                )} */}
                              <span style={{ color: "red", padding: "0px" }}>
                                {this.state.imageError}
                              </span>
                            </>
                          ) : (
                            <>
                              <div className="col-sm-12 p-3 ps-0 d-flex align-self-center">
                                {/* {this.state.bannerImage !== null && */}
                                <img
                                  src={this.state.newUrl}
                                  alt=""
                                  style={{
                                    // width: "-webkit-fill-available",
                                    height: "4em",
                                    objectFit: "contain",
                                    objectPosition: "left",
                                  }}
                                />
                                {/* } */}
                                {/* {(this.state.bannerImage === null && this.state.orgLogo !== null) &&
                                  <img
                                    src={this.state.orgLogo}
                                    alt=""
                                    style={{
                                      height: "4em",
                                      objectFit: "contain",
                                      objectPosition: "left",
                                    }}
                                  />
                                }
                                {(this.state.bannerImage === null && this.state.orgLogo === null) &&
                                  <img
                                    src={defaultWidget_logo}
                                    alt=""
                                    style={{
                                      height: "4em",
                                      objectFit: "contain",
                                      objectPosition: "left",
                                    }}
                                  />
                                } */}
                                <span className="fw-bold ms-2">
                                  {/* <Tooltip
                                    title="Change logo"
                                    classes={{ popper: "custom-tooltip" }}
                                  > */}
                                  <ClearIcon
                                    className="logoDelete"
                                    style={{
                                      cursor: "pointer",
                                      borderRadius: "50%",
                                      border: "solid 2px",
                                    }}
                                    onClick={this.deleteWidgetBannerInBackend.bind(
                                      this
                                    )}
                                  />
                                  {/* </Tooltip> */}
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="row copyIcon anchortag"
                        md={12}
                        style={{
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          margin: "1em 0 0 0",
                          color: "#337ab7",
                          gap: "8px",
                          cursor: "pointer", // makes text look clickable
                        }}
                      >
                        <CopyToClipboard
                          text={this.state.iframeCode}
                          onCopy={this.handleCopy.bind(this)}
                        >
                          <div
                            style={{
                              display: "flex",
                              // alignItems: "center",
                              gap: "6px",
                              padding: 0,
                            }}
                          >
                            <span className="p-0">
                              Copy this widget’s iFrame code for HTML.
                            </span>
                            <FileCopyIcon
                              style={{
                                color: "gray",
                                fontSize: "20px",
                              }}
                            />
                          </div>
                        </CopyToClipboard>
                        {this.state.alertVisible && (
                          <span
                            className="WidgetCopyToClipboard ms-auto text-end"
                            style={{
                              width: "190px",
                            }}
                          >
                            iFrame code copied to clipboard!
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div>
                </div> */}
              </div>
              <div className="row d-flex align-items-center justify-content-between">
                <div className="col-sm-12 text-center pt-0 p-2">
                  <a
                    href={this.state.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "#fff",
                    }}
                  >
                    <Button
                      // id="ptsHollowButton"
                      className="me-3"
                      size="small"
                      type="button"
                      style={{
                        background: "#37517e",
                        color: "#fff",
                        fontWeight: "bold",
                        textTransform: "capitalize",
                        padding: "2px 10px",
                        boxShadow:
                          "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
                      }}
                      onClick={this.updateWidgetTemplateBackend.bind(
                        this,
                        false
                      )}
                      startIcon={
                        <i
                          className="fa fa-eye"
                          style={{ fontSize: "14px" }}
                          aria-hidden="true"
                        ></i>
                      }
                    >
                      Preview & Test
                    </Button>
                  </a>
                  &nbsp;
                  <SaveButton
                    btnName="Create"
                    type="submit"
                    onClick={this.updateWidgetTemplateBackend.bind(this, true)}
                  />
                  {/* &nbsp;
                  <CancelIconButton
                    onClick={this.handleWidgetClose.bind(this)}
                  /> */}
                </div>
              </div>
            </div>
          </DialogContent >
        </Dialog >
      </>
    );
  }
}
export default WidgetTemplate;
